<script setup lang="ts">
import { onMounted, provide, ref } from 'vue';
import type { MegaMenuContext, MegaMenuPanelProps } from './MainMenu.types';

withDefaults(defineProps<MegaMenuPanelProps>(), {
  imageUrl: null,
});

const root = ref<HTMLDivElement | null>(null);
const activeSubKey = ref<string | null>(null);

const setActive = (key: string) => {
  activeSubKey.value = key;
};

onMounted(() => {
  if (activeSubKey.value !== null) {
    return;
  }
  const firstRail = root.value?.querySelector<HTMLElement>('[data-rail-key]');
  if (firstRail) {
    setActive(firstRail.dataset.railKey ?? '');
  }
});

provide<MegaMenuContext>('megaMenu', {
  activeSubKey,
  setActive,
});

defineExpose({ activeSubKey, setActive });
</script>

<template>
  <div ref="root" class="mega-menu" :data-item-key="itemKey">
    <slot :active-sub-key="activeSubKey" :set-active="setActive" />
  </div>
</template>

<style lang="scss"></style>
